import { render, staticRenderFns } from "./default.vue?vue&type=template&id=a6f4ef28&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=a6f4ef28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f4ef28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6f4ef28')) {
      api.createRecord('a6f4ef28', component.options)
    } else {
      api.reload('a6f4ef28', component.options)
    }
    module.hot.accept("./default.vue?vue&type=template&id=a6f4ef28&scoped=true&", function () {
      api.rerender('a6f4ef28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/default.vue"
export default component.exports